module.exports = __webpack_public_path__ + "static/media/user-visor.b42004b8.svg";